/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './loader.component.less.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '../../../../app/core/loader/loader.component';
const styles_LoaderComponent:any[] = [i0.styles];
export const RenderType_LoaderComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_LoaderComponent,data:{}});
export function View_LoaderComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'div',[['class',
      'loader']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(1,(null as any),['',''])),i1.ɵpid(131072,i2.TranslatePipe,[i3.TranslateService,
          i1.ChangeDetectorRef])],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵunv(_v,1,0,i1.ɵnov(_v,2).transform('CORE.loading'));
    _ck(_v,1,0,currVal_0);
  });
}
export function View_LoaderComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-loader',
      ([] as any[]),(null as any),(null as any),(null as any),View_LoaderComponent_0,
      RenderType_LoaderComponent)),i1.ɵdid(1,114688,(null as any),0,i4.LoaderComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const LoaderComponentNgFactory:i1.ComponentFactory<i4.LoaderComponent> = i1.ɵccf('app-loader',
    i4.LoaderComponent,View_LoaderComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY29yZS9sb2FkZXIvbG9hZGVyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3ZzdHMvd29yay8xL3MvZW1yLXdlYmFwcC9zcmMvYXBwL2NvcmUvbG9hZGVyL2xvYWRlci5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3ZzdHMvd29yay8xL3MvZW1yLXdlYmFwcC9zcmMvYXBwL2NvcmUvbG9hZGVyL2xvYWRlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY29yZS9sb2FkZXIvbG9hZGVyLmNvbXBvbmVudC50cy5Mb2FkZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwibG9hZGVyXCI+e3sgJ0NPUkUubG9hZGluZycgfCB0cmFuc2xhdGV9fTwvZGl2PiIsIjxhcHAtbG9hZGVyPjwvYXBwLWxvYWRlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQW9COzhCQUFBO0lBQUE7SUFBQTs7OztvQkNBcEI7TUFBQTtnQ0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/app/core/loader/loader.component.ngfactory.ts